<template>
  <header class="header">
    <div class="header__container">
      <AppButton  type="ghost" size="m" icon-position="left" :with-icon="true" @click="toggleMenu">
        <template #left><IconDefault :name="opened?'menu-close':'menu-burger'" :size="isMobile?'l':'m'" /></template>
      </AppButton>
      <div  class="logo">
        <a href="/#" @click="goHome"><HeaderLogo /></a>
      </div>
      <div v-if="!isMobile" class="center">
        <AppBreadCrumbs />
      </div>
      <div v-if="!isMobile" class="right">
        <a  href="https://sminex.com" target="_blank" title="sminex.com"><span>
          sminex.com <IconDefault name="link" :size="'s'" ></IconDefault>
          </span>
        </a>
      </div>
    </div>
    <div  class="header__mobile_navigation" :class="{opened: opened}">
      <div class="header__mobile_navigation__top">
        <AppNavMenu  :menu="menu" variant="top-menu" @click="(e, href) => openPage(e, href)"></AppNavMenu>
      </div>
    </div>
  </header>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useLayoutStore } from "@stores/layout";
import { usePagesStore } from "@stores/pages";
import { ref, type Ref } from "vue"
import HeaderLogo from "@components/HeaderLogo/index.vue";
import AppButton from "@components/AppButton/index.vue";
import IconDefault from "@components/AppIcon/index.vue";
import AppNavMenu from "@components/AppNavMenu/index.vue";
import AppBreadCrumbs from "@components/AppBreadCrumbs/index.vue";


defineOptions({
  name:'AppHeader'
})


const layoutStore = useLayoutStore();
const pagesStore = usePagesStore();
const { isMobile } = storeToRefs(layoutStore);
const { getMenu } = storeToRefs(pagesStore)
const opened:Ref = ref(false);
const menu = getMenu;
const toggleMenu = (event:Event)=>{
  opened.value = !opened.value;
}

const openPage = (event:Event, href:string) => {
  pagesStore.setPage(href);
  toggleMenu(event)
}
const goHome = ()=>{
  pagesStore.setPage('index');
}

</script>
<style scoped lang="scss">
.header {
  position: fixed;
  top: 0;
  left: 0;
  top: env(safe-area-inset-top,0px);
  width: 100%;
  height: var(--header-height);
  padding: var(--space-20) var(--space-60);
  border-bottom: 1px solid var(--color-primary-ghost-30);
  background: var(--background-primary);
  z-index: 100;
  &__container {
    display: grid;
    grid-template-columns: 10rem 1fr auto 1fr;
    align-items: center;
    @media screen and (max-width: 768px) {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .logo {
      width: 33.1rem;
      height: 3.5rem;
      @media screen and (max-width: 768px) {
        width: 23.1rem;
        margin-top: 1.5rem;
      }
      a {
        display: block;
      }
    }

    .right {
      text-align: right;

      a {
        display: inline-block;

        span {
          display: flex;
          align-items: center;
          font-size: var(--font-size-16);

          :deep(i) {
            margin-left: var(--space-14);
            color: var(--color-secondary);
            font-size: var(--font-size-20);
          }
        }

        &:hover {
          span {
            :deep(i) {
              color: var(--color-primary);
            }
          }
        }
      }
    }
  }
    @media screen and (max-width: 768px){
      padding: 0 var(--space-20);
      height: var(--header-height-mobile);

    }
  &__mobile_navigation{
    position: fixed;
    width: 100%;
    top:var(--header-height-mobile);
    left: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
    background: var(--background-primary);
    transition: all 0.5s;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.opened{
      height: 100dvh;
      opacity: 1;

    }
    &__top{
      @media screen and (min-width: 769px){
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .nav{
        margin-top: 0;
        @media screen and (max-width: 768px){
          margin-top: var(--space-32);
        }
      }
    }
    &__bottom{
      padding: var(--space-32) var(--space-16);
      display: flex;
      flex-direction: column;
      align-items: center;
      .separated_text{
        margin-top: var(--space-24);
      }
    }

  }
  }

</style>